import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export interface VehicleCost {
  vehicleCostId?: number;
  vehicleId?: number;
  description?: string;
  cost?: number;
  date?: string | Date;
}

export const getVehicleCostsByVehicle = async (vehicleId: number): Promise<VehicleCost[]> => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    throw new Error('Authorization token not found');
  }

  const response = await axios.get(
    `https://${apiURL}/VehicleCost/vehicle/${vehicleId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  );

  return response.data;
};

export const createVehicleCost = async (vehicleCost: VehicleCost): Promise<VehicleCost> => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    throw new Error('Authorization token not found');
  }

  const response = await axios.post(
    `https://${apiURL}/VehicleCost`,
    vehicleCost,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  );

  return response.data;
};

export const updateVehicleCost = async (id: number, vehicleCost: VehicleCost): Promise<VehicleCost> => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    throw new Error('Authorization token not found');
  }

  const response = await axios.put(
    `https://${apiURL}/VehicleCost/${id}`,
    vehicleCost,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  );

  return response.data;
};

export const deleteVehicleCost = async (id: number): Promise<void> => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    throw new Error('Authorization token not found');
  }

  await axios.delete(
    `https://${apiURL}/VehicleCost/${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  );
};

export const getVehicleCostDocuments = async (vehicleCostId: number): Promise<any[]> => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    throw new Error('Authorization token not found');
  }

  const response = await axios.get(
    `https://${apiURL}/VehicleCost/${vehicleCostId}/Documents`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  );

  return response.data;
};
